<div class="glass-modal-container">

  <!-- ── CABECERA GLASSMORPHISM CON SAFE-AREA ── -->
  <div class="glass-header">
    <button type="button" class="header-back-btn" (click)="dismiss()" aria-label="Volver">
      <ion-icon name="arrow-back-outline"></ion-icon>
    </button>

    <div class="header-title-box">
      <h2 class="header-title">{{ isEdit ? 'Editar ' + getTipoLabel() : 'Nuevo ' + getTipoLabel() }}</h2>
      <span class="header-subtitle">Inspección · Estimación</span>
    </div>

    <div class="header-type-badge">
      <ion-icon [name]="getTipoIcon()"></ion-icon>
      <span>{{ current.tipo }}</span>
    </div>
  </div>

  <!-- ── CONTENIDO PRINCIPAL (SOLO CAMPOS DE LA CATEGORÍA ACTIVA) ── -->
  <ion-content class="glass-content" [scrollY]="true">
    <div class="glass-body">

      <!-- ══════════════ 1. PLANILLA ══════════════ -->
      <div class="glass-card" *ngIf="current.tipo === 'PLANILLA'">
        <div class="card-heading">
          <div class="ch-icon-box">
            <ion-icon name="people-outline"></ion-icon>
          </div>
          <div class="ch-texts">
            <h3 class="ch-title">Personal Operativo</h3>
            <p class="ch-hint">Días, cuadrilla y turno de trabajo</p>
          </div>
        </div>

        <div class="glass-grid">
          <div class="glass-input-field">
            <label class="gif-label">Días de labor</label>
            <div class="gif-control-wrapper">
              <ion-input type="number" [(ngModel)]="current.dias" placeholder="0" mode="ios" min="1"></ion-input>
            </div>
          </div>
          <div class="glass-input-field">
            <label class="gif-label">Trabajadores</label>
            <div class="gif-control-wrapper">
              <ion-input type="number" [(ngModel)]="current.trabajadores" placeholder="0" mode="ios" min="1"></ion-input>
            </div>
          </div>
        </div>

        <div class="glass-grid">
          <div class="glass-input-field">
            <label class="gif-label">Turno</label>
            <div class="gif-control-wrapper clickable-input" (click)="openTurnoSelector()">
              <span class="fake-input-value">{{ current.turno === 'NOCTURNO' ? 'Nocturno' : 'Diurno' }}</span>
              <ion-icon name="chevron-down-outline" class="fake-input-arrow"></ion-icon>
            </div>
          </div>
          <div class="glass-input-field">
            <label class="gif-label">Monto Diario ($)</label>
            <div class="gif-control-wrapper">
              <ion-input type="number" [(ngModel)]="current.monto_diario" placeholder="0.00" mode="ios"></ion-input>
            </div>
          </div>
        </div>

        <!-- Banner costo proyectado planilla -->
        <div class="glass-total-banner">
          <div class="gtb-left">
            <ion-icon name="calculator-outline"></ion-icon>
            <span class="gtb-lbl">Total Planilla:</span>
          </div>
          <span class="gtb-amount">{{ (current.dias || 0) * (current.trabajadores || 0) * (current.monto_diario || 0) | currency }}</span>
        </div>

        <!-- Opción de vincular movilidad automática -->
        <div class="glass-toggle-card" *ngIf="!isEdit">
          <div class="gtc-row">
            <div class="gtc-info">
              <ion-icon name="flashlight-outline"></ion-icon>
              <div class="gtc-texts">
                <span class="gtc-title">Gastos de Movilidad</span>
                <span class="gtc-sub">Vincular combustible automáticamente</span>
              </div>
            </div>
            <ion-toggle [(ngModel)]="addMovilidad" mode="ios"></ion-toggle>
          </div>

          <div class="gtc-expanded" *ngIf="addMovilidad">
            <div class="glass-input-field">
              <label class="gif-label">Combustible Diario ($)</label>
              <div class="gif-control-wrapper">
                <ion-input type="number" [(ngModel)]="montoMovilidad" mode="ios"></ion-input>
              </div>
            </div>
            <div class="gtc-calc-hint">
              Total proyectado movilidad: <strong>{{ (current.dias || 0) * (montoMovilidad || 0) | currency }}</strong>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════ 2. MATERIAL ══════════════ -->
      <div class="glass-card" *ngIf="current.tipo === 'MATERIAL'">
        <div class="card-heading">
          <div class="ch-icon-box">
            <ion-icon name="cube-outline"></ion-icon>
          </div>
          <div class="ch-texts">
            <h3 class="ch-title">Insumos y Materiales</h3>
            <p class="ch-hint">Cantidad requerida y costo estimado unitario</p>
          </div>
        </div>

        <div class="glass-grid">
          <div class="glass-input-field">
            <label class="gif-label">Cantidad</label>
            <div class="gif-control-wrapper">
              <ion-input type="number" [(ngModel)]="current.cantidad" placeholder="0.00" mode="ios"></ion-input>
            </div>
          </div>
          <div class="glass-input-field">
            <label class="gif-label">Costo Unitario ($)</label>
            <div class="gif-control-wrapper">
              <ion-input type="number" [(ngModel)]="current.costo" placeholder="0.00" mode="ios"></ion-input>
            </div>
          </div>
        </div>

        <!-- Banner total material -->
        <div class="glass-total-banner">
          <div class="gtb-left">
            <ion-icon name="cash-outline"></ion-icon>
            <span class="gtb-lbl">Total Material:</span>
          </div>
          <span class="gtb-amount">{{ (current.cantidad || 0) * (current.costo || 0) | currency }}</span>
        </div>
      </div>

      <!-- ══════════════ 3. MOVILIDAD ══════════════ -->
      <div class="glass-card" *ngIf="current.tipo === 'MOVILIDAD'">
        <div class="card-heading">
          <div class="ch-icon-box">
            <ion-icon name="flashlight-outline"></ion-icon>
          </div>
          <div class="ch-texts">
            <h3 class="ch-title">Logística y Traslados</h3>
            <p class="ch-hint">Días y costo de movilización diario</p>
          </div>
        </div>

        <div class="glass-grid">
          <div class="glass-input-field">
            <label class="gif-label">Días</label>
            <div class="gif-control-wrapper">
              <ion-input type="number" [(ngModel)]="current.dias" placeholder="0" mode="ios"></ion-input>
            </div>
          </div>
          <div class="glass-input-field">
            <label class="gif-label">Monto Diario ($)</label>
            <div class="gif-control-wrapper">
              <ion-input type="number" [(ngModel)]="current.monto_diario" placeholder="0.00" mode="ios"></ion-input>
            </div>
          </div>
        </div>

        <!-- Banner total movilidad -->
        <div class="glass-total-banner">
          <div class="gtb-left">
            <ion-icon name="cash-outline"></ion-icon>
            <span class="gtb-lbl">Total Movilidad:</span>
          </div>
          <span class="gtb-amount">{{ (current.dias || 0) * (current.monto_diario || 0) | currency }}</span>
        </div>
      </div>

      <!-- ══════════════ 4. SUBCONTRATO ══════════════ -->
      <div class="glass-card" *ngIf="current.tipo === 'SUBCONTRATO'">
        <div class="card-heading">
          <div class="ch-icon-box">
            <ion-icon name="business-outline"></ion-icon>
          </div>
          <div class="ch-texts">
            <h3 class="ch-title">Gestión de Subcontratos</h3>
            <p class="ch-hint">Selección o alta de proveedor y costo acordado</p>
          </div>
        </div>

        <!-- Selector Subcontratista Modal Genérico -->
        <div class="glass-select-group">
          <label class="gif-label">Subcontratista <span style="color: #f87171;">*</span></label>
          
          <!-- Estado 1: Sin selección -> Toca para seleccionar -->
          <div class="big-input-box" *ngIf="!current.subcontratista" (click)="openSubcontratistaSelector()">
            <ion-icon name="business-outline" class="bi-search"></ion-icon>
            <div class="big-input">
              <span class="placeholder-text">Toca para seleccionar subcontratista...</span>
            </div>
            <ion-icon name="chevron-forward-outline" class="bi-chevron"></ion-icon>
          </div>

          <!-- Estado 2: Con selección -> Tarjeta interactiva (toca para cambiar) -->
          <div class="interactive-selection-card" *ngIf="current.subcontratista" (click)="openSubcontratistaSelector()">
            <div class="isc-top-row">
              <div class="isc-header-group">
                <div class="isc-avatar biz">
                  <ion-icon name="business"></ion-icon>
                </div>
                <div class="isc-meta">
                  <span class="isc-category">Subcontratista Asignado</span>
                  <span class="isc-count-badge">{{ current.subcontratista }}</span>
                </div>
              </div>
              <div class="isc-actions">
                <ion-icon name="close-circle" class="isc-clear-btn" (click)="clearSubcontratista($event)" title="Quitar"></ion-icon>
                <ion-icon name="chevron-forward-outline" class="isc-arrow-icon"></ion-icon>
              </div>
            </div>
            <span class="isc-hint">
              <ion-icon name="options-outline"></ion-icon>
              Toca para cambiar o seleccionar otro subcontratista
            </span>
          </div>
        </div>

        <div class="glass-input-field">
          <label class="gif-label">Costo Total Acordado ($)</label>
          <div class="gif-control-wrapper">
            <ion-input type="number" [(ngModel)]="current.costo" placeholder="0.00" mode="ios"></ion-input>
          </div>
        </div>

        <div class="glass-total-banner">
          <div class="gtb-left">
            <ion-icon name="cash-outline"></ion-icon>
            <span class="gtb-lbl">Total Acordado:</span>
          </div>
          <span class="gtb-amount">{{ (current.costo || 0) | currency }}</span>
        </div>
      </div>

      <!-- ══════════════ 5. OBSERVACIONES / NOTA ══════════════ -->
      <div class="glass-card">
        <div class="card-heading">
          <div class="ch-icon-box">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon>
          </div>
          <div class="ch-texts">
            <h3 class="ch-title">{{ current.tipo === 'GENERAL' || current.tipo === 'NOTA' ? 'Detalle de la Nota' : 'Observaciones' }}</h3>
            <p class="ch-hint">Detalles, aclaraciones o comentarios adicionales</p>
          </div>
        </div>

        <div class="glass-textarea-box">
          <textarea [(ngModel)]="current.comentario" rows="4"
            [placeholder]="current.tipo === 'GENERAL' || current.tipo === 'NOTA' ? 'Escribe el contenido de la nota...' : 'Escribe observaciones opcionales...'"></textarea>
        </div>
      </div>

    </div>
  </ion-content>

  <!-- ── FOOTER DE ACCIONES ── -->
  <div class="glass-footer">
    <button type="button" *ngIf="isEdit" (click)="deleteItem()" [disabled]="loading" class="btn-delete">
      <ion-icon name="trash-outline"></ion-icon>
      <span>Eliminar</span>
    </button>

    <button type="button" (click)="save()" [disabled]="loading || (current.tipo === 'SUBCONTRATO' && !isSubRegistrado)" class="btn-save">
      <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
      <ion-icon *ngIf="!loading" name="save-outline"></ion-icon>
      <span>{{ loading ? 'Guardando...' : (isEdit ? 'Actualizar' : 'Guardar') }}</span>
    </button>
  </div>

</div>
